import React from 'react';

const SvgOffice = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M20.44 9.04c.533 0 .973.401 1.033.919l.007.121v5.44a1.04 1.04 0 01-2.073.12l-.007-.12v-5.44c0-.574.466-1.04 1.04-1.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M23.56 14.48c.574 0 1.04.465 1.04 1.04v11.44h5.72c.862 0 1.56.698 1.56 1.56v1.32H20.44a1.04 1.04 0 00-1.034.927l-.006.113v6.427h-5.2a1.04 1.04 0 00-1.04 1.04v37.234H9V28.52c0-.862.698-1.56 1.56-1.56h5.72V15.52c0-.575.466-1.04 1.04-1.04h6.24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M51.81 8v15.6h-2.08V8z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#59DD7D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.56 8h6.857c1.191 0 2.156.965 2.156 2.156v2.374c0 1.19-.965 2.156-2.156 2.156h-4.701a2.156 2.156 0 01-2.156-2.156V8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.067 12.457h6.857c1.19 0 2.156.965 2.156 2.156v2.374c0 1.19-.965 2.156-2.156 2.156h-4.701a2.156 2.156 0 01-2.156-2.156v-4.53z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.48 31.92)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M1 0h56.24a1 1 0 011 1v9.4H0V1a1 1 0 011-1z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 3.12,
  x: 4.16,
  y: 2.392,
  fill: "#8D8D8D",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 3.12,
  x: 44.72,
  y: 2.392,
  fill: "#8D8D8D",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 3.12,
  x: 11.44,
  y: 2.392,
  fill: "#8D8D8D",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 3.12,
  x: 52,
  y: 2.392,
  fill: "#8D8D8D",
  rx: 1.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.24 21.708)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M24.441 5.956L34.881.26a1 1 0 01.958 0l10.44 5.695a1 1 0 01.521.878V17.68h22.88c.574 0 1.04.466 1.04 1.04v39.64H0V18.72c0-.574.466-1.04 1.04-1.04h22.88V6.834a1 1 0 01.521-.878z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.36,
  cy: 10.4,
  r: 3.12,
  fill: "#BDBDBD"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M35.36 39.52a5.2 5.2 0 015.2 5.2v13.52h-10.4V44.72a5.2 5.2 0 015.2-5.2zM14.56 43.68a5.2 5.2 0 015.2 5.2v9.36H9.36v-9.36a5.2 5.2 0 015.2-5.2zM56.16 43.68a5.2 5.2 0 015.2 5.2v9.36h-10.4v-9.36a5.2 5.2 0 015.2-5.2zM35.36 18.72a5.2 5.2 0 015.2 5.2v8.398h-10.4V23.92a5.2 5.2 0 015.2-5.2zM14.56 23.92a5.2 5.2 0 015.2 5.2v3.198H9.36V29.12a5.2 5.2 0 015.2-5.2zM56.16 23.92a5.2 5.2 0 015.2 5.2v3.198h-10.4V29.12a5.2 5.2 0 015.2-5.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M36.14 18.72v13.598h-1.56V18.72zM15.34 23.92v8.398h-1.56V23.92zM56.94 23.92v8.398h-1.56V23.92z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(78.68 56.36)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M8.008 13.936v9.9h-1.56v-9.9z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.488,
  cy: 7.488,
  r: 7.488,
  fill: "#59DD7D"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.28 64.68)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M5.928 5.616v9.9h-1.56v-9.9z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.2,
  cy: 5.2,
  r: 5.2,
  fill: "#59DD7D"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M58.49 95.36c3.116-3.016 3.911-5.546 2.958-7.176-2.07-3.542-5.648-4.297-5.648-8.236H45.4c0 4.508 4.91 5.11 4.91 7.93 0 2.82-3.473 5.982-5.95 7.482h14.13z"
})));

export default SvgOffice;